import { CalendarIcon } from 'lucide-react';
import { DropdownMenuItem } from '../../../components/ui/dropdown-menu.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import type { CustomerBasics } from '../../../server/types/infer-trpc-types.ts';
import { Can } from '../../acl/can.tsx';
import { DialogStateManager } from '../../dialog/dialog-provider.tsx';
import type { EventCreateDialogProps } from './event-create-dialog.tsx';
import { EventCreateDialog } from './event-create-dialog.tsx';

type Props = {
    customer?: CustomerBasics;
    onCreated?: () => void;
    analyticsSource: EventCreateDialogProps['analyticsSource'];
};

export function DropdownMenuItemCreateEvent({ customer, onCreated, analyticsSource }: Props) {
    const { t } = useLocale();

    const handleEventCreationClick = () => {
        void DialogStateManager.show(EventCreateDialog, {
            customer,
            onCreated,
            analyticsSource,
        } satisfies EventCreateDialogProps);
    };

    return (
        <Can I="create" a="CustomerEvent">
            <DropdownMenuItem onSelect={handleEventCreationClick}>
                <CalendarIcon className="h-4 w-4" />
                <span>{t('top_navbar__new_event')}</span>
            </DropdownMenuItem>
        </Can>
    );
}
